/**
 * Created by PanJiaChen on 16/11/18.
 */
import store from "@/store";
/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
// 传入参数（数组数据，数组下标，精度），echarts的饼图最大余额法
export function getPercentValue(valueList, idx, precision) {
  // 判断是否为空
  if (!valueList[idx]) {
    return 0;
  }
  // 求和
  var sum = valueList.reduce(function (acc, val) {
    return acc + (isNaN(val) ? 0 : val);
  }, 0);
  if (sum === 0) {
    return 0;
  }
  // 10的2次幂是100，用于计算精度。
  var digits = Math.pow(10, precision);
  // 扩大比例100，
  var votesPerQuota = valueList.map(function (val) {
    return ((isNaN(val) ? 0 : val) / sum) * digits * 100;
  });
  // 总数，扩大比例意味的总数要扩大
  var targetSeats = digits * 100;
  // 再向下取值，组成数组
  var seats = votesPerQuota.map(function (votes) {
    return Math.floor(votes);
  });
  // 再新计算合计，用于判断与总数量是否相同，相同则占比会100%
  var currentSum = seats.reduce(function (acc, val) {
    return acc + val;
  }, 0);
  // 余数部分的数组：原先数组减去向下取值的数组，得到余数部分的数组
  var remainder = votesPerQuota.map(function (votes, idx) {
    return votes - seats[idx];
  });
  // 给最大最大的余额加1，凑个占比100%；
  while (currentSum < targetSeats) {
    //  找到下一个最大的余额，给其加1
    var max = Number.NEGATIVE_INFINITY;
    var maxId = null;
    for (var i = 0, len = remainder.length; i < len; ++i) {
      if (remainder[i] > max) {
        max = remainder[i];
        maxId = i;
      }
    }
    // 对最大项余额加1
    ++seats[maxId];
    // 已经增加最大余数加1，则下次判断就可以不需要再判断这个余额数。
    remainder[maxId] = 0;
    // 总的也要加1，为了判断是否总数是否相同，跳出循环。
    ++currentSum;
  }
  // 这时候的seats就会总数占比会100%
  return seats[idx] / digits;
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  } else if (!time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf("?") + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;
    else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xdc00 && code <= 0xdfff) i--;
  }
  return s;
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return "";
  return cleanArray(
    Object.keys(json).map((key) => {
      if (json[key] === undefined) return "";
      return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
    })
  ).join("&");
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split("?")[1];
  if (!search) {
    return {};
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, " ") +
      '"}'
  );
}

/**
 * 将数组序列化为JSON字符串进行URL编码
 * @param {string[]} values
 * @returns {string} 编码后的URL安全字符串
 */
export function encodeAdvanced(values) {
  try {
    // 1. 将数组转为JSON字符串
    const jsonString = JSON.stringify(values);
    // 2. 对JSON字符串进行URL编码
    return encodeURIComponent(jsonString);
  } catch (error) {
    return "";
  }
}

export function decodeAdvanced(encodedText) {
  if (!encodedText) return [];
  try {
    // 1. URL解码然后解析JSON
    const jsonString = decodeURIComponent(encodedText);
    // 2. JSON解析回数组
    return JSON.parse(jsonString);
  } catch (error) {
    return [];
  }
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement("div");
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== "object") {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach((property) => {
    const sourceProperty = source[property];
    if (typeof sourceProperty === "object") {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += "" + className;
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === "start") {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "deepClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

export function setBarMaxVal(array, isPercent = false) {
  const arr = array.filter((item) => item != "-");
  const max = Math.max(...arr);
  let result = "";
  let stringMax = parseInt(max).toString();
  let num = 5;
  if (stringMax.length > 2) {
    num = Math.pow(10, stringMax.length - 2) * 5;
  }
  if (!isPercent) {
    result = Math.ceil(max / num) * num;
  } else {
    result = Math.ceil((max * 100) / num) * num;
  }
  if (result < 0) {
    return 0;
  } else {
    return result;
  }
}

export function setBarMinVal(array, isPercent = false) {
  const arr = array.filter((item) => item != "-");
  const min = Math.min(...arr);
  let result = "";
  let stringMin = parseInt(min).toString();
  let num = 5;
  if (stringMin.length > 2) {
    num = Math.pow(10, stringMin.length - 2) * 5;
  }
  if (!isPercent) {
    result = Math.floor(min / num) * num;
  } else {
    result = Math.floor((min * 100) / num) * num;
  }
  if (result > 0) {
    return 0;
  } else {
    return result;
  }
}
/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + "";
  const randomNum = parseInt((1 + Math.random()) * 65536) + "";
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += " " + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
    ele.className = ele.className.replace(reg, " ");
  }
}

/***
 * 将对象转为数组，仅限一层键值对
 */
export function coverObjToArr(obj) {
  return Object.keys(obj).map(function (i) {
    return { name: i, value: obj[i] }; // obj[i];
  });
}
export function threeDigitsPercentage(data) {
  //数字转百分比保留小数点后3位不会4舍5入
  let data1 = Math.floor(data * 10000) / 100 + "%";
  return data1;
}
/***
 *获取浏览器地址栏参数
 */
export function getUrlParams(params) {
  var urlObj = {};
  if (!window.location.hash.split("?")[1]) {
    return false;
  }
  var urlParams = window.location.hash.split("?")[1];
  var urlArr = urlParams.split("&");
  for (var i = 0; i < urlArr.length; i++) {
    var urlArrItem = urlArr[i].split("=");
    if (urlArrItem[0] == "plat") {
    }
    urlObj[urlArrItem[0]] = decodeURIComponent(urlArrItem[1]);
  } // 判断是否有参数
  if (arguments.length >= 1) {
    return urlObj[params];
  }
  return urlObj;
}

//设置浏览器地址栏参数
export function setUrlParams(Url, params, val) {
  if (!Url.split("?")[1]) {
    return Url + "?" + params + "=" + val;
  }
  var urlParams = Url.split("?")[1];
  var urlArr = urlParams.split("&");
  let str = "";
  if (urlParams.indexOf(params) < 0) {
    return Url + "&" + params + "=" + val;
  } else {
    for (var i = 0; i < urlArr.length; i++) {
      var urlArrItem = urlArr[i].split("=");
      if (urlArrItem[0] == params) {
        str = urlArrItem[0] + "=" + urlArrItem[1];
        return Url.replace(str, params + "=" + val);
      }
    }
  }
}

function filter(str) {
  // 特殊字符转义
  str += ""; // 隐式转换
  str = str.replace(/%/g, "%25");
  str = str.replace(/\+/g, "%2B");
  str = str.replace(/ /g, "%20");
  str = str.replace(/\//g, "%2F");
  str = str.replace(/\?/g, "%3F");
  str = str.replace(/&/g, "%26");
  str = str.replace(/=/g, "%3D");
  str = str.replace(/#/g, "%23");
  return str;
}

export function formateObjToParamStr(paramObj) {
  const sdata = [];
  for (let attr in paramObj) {
    sdata.push(`${attr}=${filter(paramObj[attr])}`);
  }
  return sdata.join("&");
}

//从浏览器地址栏中读取参数
export function getObjFromUrl(url) {
  var args = url.split("?");
  if (args[0] == url) {
    return "";
  }
  var arr = args[1].split("&");
  var obj = {};
  for (var i = 0; i < arr.length; i++) {
    var arg = arr[i].split("=");
    obj[arg[0]] = arg[1];
  }
  return obj;
}

//获取指定年月的上一个月
export function getLastMonth(data) {
  var year, lastMonth;
  var date = new Date(data);
  var nowYear = date.getFullYear();
  var nowMonth = date.getMonth();
  if (nowMonth == 0) {
    year = nowYear - 1;
    lastMonth = 12;
  } else {
    year = nowYear;
    lastMonth = nowMonth;
  }
  lastMonth = lastMonth < 10 ? "0" + lastMonth : lastMonth;
  let lastYearMonth = year + "-" + lastMonth;
  return lastYearMonth;
}

//处理品牌下拉选项问题
export function handelBrandNameOptions(newVal, brandOptions) {
  /* if (!brandOptions) {
    return [];
  }*/
  let options = brandOptions;
  if (!newVal || !newVal.length) {
    return options;
  } else {
    let otherOptions = store.state.user.brandName;
    let defaultBrandOptions = localStorage.getItem("defaultBrandOption")
      ? JSON.parse(localStorage.getItem("defaultBrandOption"))
      : [];
    let arr = [...brandOptions, ...otherOptions, ...defaultBrandOptions];
    let newArr = [];
    arr.map((item) => {
      let isExit = newArr.find((item2) => {
        if (item2.id == item.id) {
          return item2;
        }
      });
      if (!isExit) {
        newArr.push(item);
      }
    });
    return newArr;
  }
}

//两个数组合并去重
export function MergeDeduplicationArray(arr1, arr2) {
  let oldBrandOptions1 = JSON.parse(JSON.stringify(arr1));
  let oldBrandOptions2 = JSON.parse(JSON.stringify(arr2));
  let newOptions = [];
  let a = [...oldBrandOptions1, ...oldBrandOptions2];
  let b = new Set(a);
  newOptions = [...b];
  return newOptions;
}

//将数字转为千分位
export function transformNum(val) {
  return val.toString().replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,");
}

//根据当前浏览器地址中获取的id设置相应的name(目前只有brand品牌用到)，用于解决location带来的无法session隔离的问题
export function initLocalName(ids, names) {
  let NewNames = [];
  if (ids && ids.length && names && names.length) {
    NewNames = names.filter((item) => {
      return ids.find((id) => {
        return id == item.id;
      });
    });
  }
  return NewNames;
}

//设置当前tab
export function setActivedTab(val) {
  if (store.state.user.ActivedTab != val) {
    store.dispatch("user/changeActivedTab", val);
  }
}
//两个对象的深度合并
export function deepMerge(obj1, obj2) {
  let key;
  for (key in obj2) {
    obj1[key] =
      obj1[key] &&
      typeof obj1[key] === "object" &&
      obj2[key] &&
      typeof obj2[key] === "object"
        ? deepMerge(obj1[key], obj2[key])
        : (obj1[key] = obj2[key]);
  }
  return obj1;
}

// 设置custom_filters参数方法
export function buildCustomFilters(store) {
  const user = store.state.user;
  const getArray = (str, delimiter = ",") => (str ? str.split(delimiter) : []);
  const wordsArray = getArray(user.words);
  const aspectTypeArray = getArray(user.aspectType);
  const ruleIdArray = getArray(user.routerRuleId);
  const analyseTypArray = getArray(user.routerAnalyseTyp);
  const labelLevelArray = getArray(user.labelLevel);
  const issueIdArray = getArray(user.issue_id, "-");
  // 构建主过滤器
  const mainFilters =
    wordsArray.length > 0
      ? wordsArray.map((word, index) => {
          const aspectTypeCode = aspectTypeArray[index];
          // 使用映射表
          const aspectTypeMap = {
            1: "",
            2: "1",
            3: "0",
            4: "0",
            5: "2",
          };
          return {
            rule_id: ruleIdArray[index] || "",
            analyse_typ: analyseTypArray[index] || "",
            label_level: labelLevelArray[index] || "",
            words: word,
            issue_id: issueIdArray[index] || "",
            aspect_type: aspectTypeMap[aspectTypeCode] || "",
          };
        })
      : [];

  // 构建 CF 过滤器
  const cfFilters = (user.cf_selected_type || []).map(
    (selectedType, index) => ({
      selected_type: selectedType,
      words: (user.cf_word || [])[index] || "",
    })
  );

  // 合并并返回
  return [...mainFilters, ...cfFilters];
}
